
import './_style/theme.basic.styl'
import './_style/global.styl'
import DoAmount from './DoAmount/index.js'
import DoHlsVideo from './DoHlsVideo/index.js'
import DoProgressBar from './DoProgressBar/index.js'

const components = [
    DoAmount,
    DoHlsVideo,
    DoProgressBar
]

const install = function (Vue) {
    components.forEach(component => {
        Vue.component(component.name, component)
    })
}

if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
}

export default {
    install,
    DoAmount,
    DoHlsVideo,
    DoProgressBar
}

export {
    install,
    DoAmount,
    DoHlsVideo,
    DoProgressBar
}